import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCalculatedFulfillmentDelay = {
  name: "getCalculatedFulfillmentDelay" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ calculatedFulfillmentDelayDays: z.number().optional() }),
};
